/* @flow */

import { type Cobranca } from '../../cobranca/types';
import xhr from '../../utils/xhr';
import getInputPorId from '../../utils/get-input-por-id';
import getSelectPorId from '../../utils/get-select-por-id';

export const editarCobranca = async (empresasId: number, dados: Cobranca | any) => {
    await xhr.put(`/empresas/cobranca/${empresasId}`, dados);
};

const preencherFormularioCobranca = (cobranca: Cobranca) => {
    const inputValorPlano = getInputPorId('valor-plano');
    if (cobranca.mensalista === '1') {
        getInputPorId('isMensalista-sim').checked = true;
    }
    if (cobranca.mensalista === '0') {
        getInputPorId('isMensalista-nao').checked = true;
    }

    getSelectPorId('origem-pagamento').value = String(cobranca.origemPagamento);
    getInputPorId('dia-vencimento').value = String(cobranca.diaVencimento);
    getSelectPorId('plano').value = String(cobranca.plano);
    inputValorPlano.value = String(cobranca.valorPlano);
    getSelectPorId('tipo-aplicativo').value = String(cobranca.tipoAplicativo);

    if (cobranca.mensalista === '1') {
        getInputPorId('isMensalista-sim').checked = true;
    }
    if (cobranca.mensalista === '0') {
        getInputPorId('isMensalista-nao').checked = true;
    }
};

export default preencherFormularioCobranca;
